import { useTheme as useThemeDefault } from 'styled-components';
import { ThemeType } from '~/styles/themes';

const useTheme = () => useThemeDefault() as ThemeType;

export default useTheme;
